var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[(!_vm.$store.state.utils.loaded)?_c('div',{staticClass:"main-loading"},[_c('strong',[_vm._v("Loading....")])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }